import { View, Text, TouchableOpacity, ScrollView } from "react-native";
import React, { useState } from "react";

import Fonts from "../../Resources/Fonts";
import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";

import WorkoutRowView from "../Workout/WorkoutRowView";
import { Feather } from "@expo/vector-icons";
import AddRow from "../Components/AddRow";
import Workout from "../Firestore/Workout";
import Exercise from "../Firestore/Exercise";
import { v4 as uuidv4 } from "uuid";

import { Menu, MenuItem } from "react-native-material-menu";
import { observer } from "mobx-react";
import { useScreenDimensions, useDevice } from "./../_layout";
import CustomAlert from "../Components/CustomAlert";
import Tooltip from "../Components/Tooltip";
import { useTranslation } from "react-i18next";
import { runInAction } from "mobx";

const BlockDescriptionView = observer(({ block }) => {
  const { t, i18n } = useTranslation();

  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const coach = block.client?.coach ?? block.coach;

  const isSameDay = (date1, date2) => {
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  };

  const [showingDeleteWeekAlert, setShowingDeleteWeekAlert] = useState(false);
  const deleteWeekAlertTitle = "deleteWeekAlertTitle-string";
  const deleteWeekAlertText = t("deleteWeekAlertText-string", {
    week: block.weekToDelete,
  });
  const [showingMaximumWeeksReachedAlert, setShowingMaximumWeeksReachedAlert] =
    useState(false);
  const [
    showingAccessoriesNotAddedToWeekAlert,
    setShowingAccessoriesNotAddedToWeekAlert,
  ] = useState(false);
  const [showingSlotsNotAddedToWeekAlert, setShowingSlotsNotAddedToWeekAlert] =
    useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [warningActionType, setWarningActionType] = useState("singleWeek");

  const [weekPicker, setWeekPicker] = useState(false);
  const showWeekPicker = () => setWeekPicker(true);

  const handleSelectedWeek = (index) => {
    const prevWeek = block.selectedWeek;
    block.setProperty("selectedWeek", index + 1);
    if (prevWeek != index + 1) {
      block.setSelectedWorkout(block.selectedWeekWorkouts[0]);
    }
    setWeekPicker(false);
  };

  const addWorkout = () => {
    const newOrder =
      block.selectedWeekWorkouts.length > 0
        ? Math.max(...block.selectedWeekWorkouts.map((w) => w.order)) + 1
        : 0;

    const newWorkout = new Workout(
      uuidv4(),
      null,
      i18n.language == "en"
        ? `Day ${String(block.selectedWeekWorkouts.length + 1)}`
        : `Día ${String(block.selectedWeekWorkouts.length + 1)}`,
      newOrder,
      block.selectedWeek,
      true,
      block,
      []
    );
    newWorkout.setProperty("hasChanged", true);
    block.workouts.push(newWorkout);
    block.setSelectedWorkout(newWorkout);

    block.client.updateClientTransactionData(block.id);
    block.client.startOrResetBatchTimer();
  };

  const BlockButtons = () => {
    const WeekPicker = observer(() => {
      const [isHovered, setIsHovered] = useState(false);

      const MenuItemView = ({ index }) => {
        const [isHovered, setIsHovered] = useState(false);
        const [isDeleteHovered, setIsDeleteHovered] = useState(false);

        return (
          <MenuItem
            onPress={() => handleSelectedWeek(index)}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                gap: 24,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 8,
                  flexShrink: 1,
                }}
              >
                {block.isWeekHidden(index + 1) && (
                  <Feather
                    name={"eye-off"}
                    size={14}
                    color={Colors.grayColor}
                  />
                )}

                <Text
                  style={{
                    fontSize: 14,
                    fontWeight: isHovered ? "600" : "normal",
                    flexShrink: 1,
                    minWidth: 80,
                  }}
                  numberOfLines={1}
                >
                  {block.getWeekName(index + 1)
                    ? block.getWeekName(index + 1)
                    : t("weekWithNumber-string", { week: index + 1 })}
                </Text>
              </View>

              <TouchableOpacity
                onPress={() => {
                  setShowingDeleteWeekAlert(true);
                  block.setProperty("weekToDelete", index + 1);
                  setWeekPicker(false);
                }}
                onMouseEnter={() => !isMobile && setIsDeleteHovered(true)}
                onMouseLeave={() => setIsDeleteHovered(false)}
              >
                <Feather
                  name="x"
                  size={14}
                  color={isDeleteHovered ? Colors.redColor : Colors.grayColor}
                  style={{ margin: -4 }}
                />
              </TouchableOpacity>
            </View>
          </MenuItem>
        );
      };
      const EyeButton = observer(() => {
        const [isHoveredEye, setIsHoveredEye] = useState(false);
        return (
          <Tooltip
            content={
              block.isWeekHidden(block.selectedWeek)
                ? "showWeek-string"
                : "hideWeek-string"
            }
            placement="top"
            delayedOpen={true}
          >
            <TouchableOpacity
              style={{
                paddingRight: 8,
                alignItems: "center",
                outlineStyle: "none",
                outlineWidth: 0,
                outlineColor: "transparent",
              }}
              onPress={() => block.toggleHiddenWeek(block.selectedWeek)}
              onMouseEnter={() => !isMobile && setIsHoveredEye(true)}
              onMouseLeave={() => setIsHoveredEye(false)}
            >
              <Feather
                name={
                  block.isWeekHidden(block.selectedWeek) ? "eye-off" : "eye"
                }
                size={14}
                color={
                  block.isWeekHidden(block.selectedWeek) &&
                  block.selectedWeek != 1
                    ? Colors.grayColor
                    : Colors.blackColor
                }
                style={{ opacity: isHoveredEye ? 0.8 : 1 }}
              />
            </TouchableOpacity>
          </Tooltip>
        );
      });
      return (
        <View style={{ flexShrink: 1 }}>
          <Menu
            visible={weekPicker}
            anchor={
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                {block.selectedWeek != 1 && <EyeButton />}
                <TouchableOpacity
                  onPress={showWeekPicker}
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    opacity: isHovered ? 0.5 : 1,
                    flexShrink: 1,
                  }}
                  onMouseEnter={() => !isMobile && setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <Text
                    style={[
                      Fonts.medium14,
                      {
                        fontSize: screenSize === "small" ? 14 : 14,
                        paddingBottom: 2,
                        flexShrink: 1,
                        minWidth: 0,
                      },
                    ]}
                    numberOfLines={1}
                  >
                    {block.getWeekName(block.selectedWeek)
                      ? block.getWeekName(block.selectedWeek)
                      : t("weekWithNumber-string", {
                          week: block.selectedWeek,
                        })}
                  </Text>
                  <Feather
                    name="chevron-down"
                    size={20}
                    color={Colors.blackColor}
                    style={{ paddingHorizontal: 4 }}
                  />
                </TouchableOpacity>
              </View>
            }
            style={[GlobalStyles.menu, { maxHeight: 500, overflow: "hidden" }]} // Set a max height for the menu
            onRequestClose={() => setWeekPicker(false)}
          >
            <ScrollView>
              {Array.from({ length: block.getWeeks }, (_, index) => (
                <MenuItemView index={index} key={index} />
              ))}
            </ScrollView>
          </Menu>
        </View>
      );
    });

    const ButtonAddWeek = observer(() => {
      const [isHovered, setIsHovered] = useState(false);

      const [showingCopyWeek, setCopyWeek] = useState(false);
      const showCopyWeek = () => setCopyWeek(true);

      const showCopyActualToTarget =
        block?.protocols?.filter((p) => p.protocolWeek === block.getWeeks + 1)
          ?.length === 0 &&
        block.workouts.some((workout) =>
          workout.exercises.some((e) => e.hasSeriesWithData)
        );
      // block?.protocolsAndExercises?.length === 0;

      const copyWeek = (newWeek, mode = "target") => {
        const selectedWeekWorkouts = block.workouts
          .filter((workout) => workout.week === block.selectedWeek)
          .sort((a, b) => a.date - b.date);

        // Create a map of weekdays based on sorted weekWorkouts
        const weekdaysAndDates = selectedWeekWorkouts.map((workout) => {
          const date = new Date(workout.date);
          return workout.date
            ? new Date(date.setDate(date.getDate() + 7))
            : null;
        });

        runInAction(() => {
          selectedWeekWorkouts.forEach((workout, index) => {
            const newDate = weekdaysAndDates[index % weekdaysAndDates.length];

            const workoutForDate = block.client
              .getWorkouts()
              .find((workout) =>
                isSameDay(new Date(workout.date), new Date(newDate))
              );

            const newWorkout = new Workout(
              undefined,
              workoutForDate !== undefined ? null : newDate,
              workout.name,
              workout.order,
              newWeek,
              false,
              block,
              []
            );

            let usedOrderValues = new Set();
            const sortedExercises =
              workout.exercises &&
              [...workout.exercises].sort((a, b) => a.order - b.order);

            sortedExercises &&
              sortedExercises.forEach((exercise, index) => {
                const protocolExercise = block.protocols.find(
                  (p) =>
                    p.protocolSlot &&
                    p.protocolSlot === exercise.protocolSlot &&
                    p.protocolWeek === newWeek &&
                    !p.isSecondaryProtocol
                );
                if (exercise.isSecondaryProtocol && protocolExercise) {
                  console.log(
                    "Skipping early since there is a protocolExercise"
                  );
                  return;
                }

                let exerciseOrder = exercise.order;

                // Ensure that no two exercises share the same order
                while (usedOrderValues.has(exerciseOrder)) {
                  exerciseOrder++; // Increment the order if it's already used
                }

                // Track the exercise order
                usedOrderValues.add(exerciseOrder);

                const isSelected = index === 0 ? true : false;

                const newExercise = new Exercise(
                  undefined,
                  exercise.name,
                  exercise.originalName,
                  exercise.notes,
                  exerciseOrder,
                  true,
                  isSelected,
                  newWorkout,
                  [],
                  [],
                  undefined,
                  undefined,
                  exercise.link
                );

                newExercise.protocolSlot = exercise.protocolSlot;
                newExercise.protocolText = exercise.protocolText;
                newExercise.isSecondaryProtocol = exercise.isSecondaryProtocol;

                if (protocolExercise) {
                  console.log("if protocolExercise");
                  newExercise.name = protocolExercise.name;
                  newExercise.originalName = protocolExercise.originalName;
                  newExercise.notes = protocolExercise.notes;
                  newExercise.protocolText = protocolExercise.protocolText;
                  newExercise.link = protocolExercise.link;

                  protocolExercise.series?.forEach((serie) => {
                    newExercise.copySerie(serie, false, mode);
                  });

                  protocolExercise.attributes?.forEach((attribute) => {
                    newExercise.copyAttribute(attribute);
                  });

                  if (protocolExercise.secondProtocolExercise) {
                    const secondExercise = new Exercise(
                      undefined,
                      protocolExercise.secondProtocolExercise.name,
                      protocolExercise.secondProtocolExercise.originalName,
                      "",
                      exerciseOrder + 1,
                      true,
                      false,
                      null,
                      [],
                      [],
                      null,
                      this,
                      protocolExercise.secondProtocolExercise.link
                    );

                    secondExercise.protocolSlot = protocolExercise.protocolSlot;
                    secondExercise.protocolText =
                      protocolExercise.secondProtocolExercise.protocolText;
                    secondExercise.isSecondaryProtocol = true;

                    protocolExercise.secondProtocolExercise?.series.forEach(
                      (oldSerie) => {
                        secondExercise.copySerie(oldSerie, false, mode);
                      }
                    );

                    protocolExercise.secondProtocolExercise?.attributes.forEach(
                      (oldAttribute) => {
                        secondExercise.copyAttribute(oldAttribute);
                      }
                    );

                    usedOrderValues.add(exerciseOrder + 1);
                    secondExercise.workout = newWorkout;

                    newWorkout.exercises.push(secondExercise);
                  }
                } else {
                  console.log("else protocolExercise");
                  exercise.series?.forEach((serie) => {
                    newExercise.copySerie(serie, false, mode);
                  });

                  exercise.attributes?.forEach((attribute) => {
                    newExercise.copyAttribute(attribute);
                  });
                }
                newWorkout.exercises.push(newExercise);
              });

            newWorkout.setProperty("hasChanged", true);
            block.workouts.push(newWorkout);
          });
        });

        handleSelectedWeek(newWeek - 1);
      };

      const createPendingWeeks = () => {
        const startWeek = block.getWeeks + 1;
        const endWeek = block.totalWeeks;
        console.log("createPendingWeeks", startWeek, endWeek);
        for (let week = startWeek; week <= endWeek; week++) {
          console.log("copying target");
          copyWeek(week);
        }
      };

      const createNewWeek = (mode) => {
        if (block.getWeeks < 24) {
          copyWeek(block.getWeeks + 1, mode);
        } else {
          setShowingMaximumWeeksReachedAlert(true);
        }
      };

      const checkWarningsAndCopyWeek = (action, actionType) => {
        if (block.protocolsAndExercises.length === 0) {
          // skip all warnings and directly execute actions
          action();
          return;
        }

        const anySlotNotAddedToWorkout =
          block.slotExercisesForLayout("squat", block.selectedWeek).length >
            0 ||
          block.slotExercisesForLayout("benchPress", block.selectedWeek)
            .length > 0 ||
          block.slotExercisesForLayout("deadlift", block.selectedWeek).length >
            0;

        const weekAccessories = block.workouts
          .filter((workout) => workout.week === block.selectedWeek)
          .flatMap((workout) =>
            workout.exercises.filter((ex) => !ex.protocolSlot)
          );

        if (anySlotNotAddedToWorkout) {
          // Store the action to execute when user confirms
          setWarningActionType(actionType);
          setPendingAction(() => action);
          setShowingSlotsNotAddedToWeekAlert(true);
        } else if (weekAccessories.length === 0) {
          // Store the action to execute when user confirms
          setWarningActionType(actionType);
          setPendingAction(() => action);
          setShowingAccessoriesNotAddedToWeekAlert(true);
        } else {
          // No warnings, execute action directly
          action();
        }
      };

      const MenuItemView = ({ index }) => {
        const [isHovered, setIsHovered] = useState(false);

        return index === 0 ? (
          <MenuItem
            onPress={() =>
              checkWarningsAndCopyWeek(
                () => createNewWeek("target"),
                "singleWeek"
              )
            }
            style={{ minWidth: 210 }}
            textStyle={{
              fontSize: 14,
              fontWeight: isHovered ? "600" : "normal",
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <Text>{t("createNextWeek-string")}</Text>
          </MenuItem>
        ) : index === 1 ? (
          <MenuItem
            onPress={() =>
              checkWarningsAndCopyWeek(
                () => createNewWeek("targetToActual"),
                "singleWeek"
              )
            }
            style={{
              minWidth: 290,
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
            textStyle={{
              fontSize: 14,
              fontWeight: isHovered ? "600" : "normal",
              // justifyContent: "center",
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <Text>{t("createNextWeek-string")}</Text>
            <Text
              style={{
                fontSize: 12,
                marginLeft: 6,
                color: Colors.grayColor,
                fontWeight: "normal",
              }}
            >
              {"("}
              {t("actualToTarget-string")}
              {")"}
            </Text>
          </MenuItem>
        ) : (
          index === 2 && (
            <MenuItem
              onPress={() =>
                checkWarningsAndCopyWeek(
                  () => createPendingWeeks(),
                  "multipleWeeks"
                )
              }
              style={{ minWidth: 260 }}
              textStyle={{
                fontSize: 14,
                fontWeight: isHovered ? "600" : "normal",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <Text>
                {t("createWeeksXtoY-string", {
                  x: block.getWeeks + 1,
                  y: block.totalWeeks,
                })}
              </Text>
            </MenuItem>
          )
        );
      };

      // Check if all workouts have at least one exercise in the selected week
      const selectedWeekWorkouts = block.workouts.filter(
        (workout) => workout.week === block.selectedWeek
      );
      const allWorkoutsHaveExercises =
        selectedWeekWorkouts.length > 0 &&
        selectedWeekWorkouts.every(
          (workout) => workout.exercises && workout.exercises.length > 0
        );
      const hasReachedMaxWeeks = block.getWeeks === block.totalWeeks;

      // Check if there are protocols or exercises with protocolSlot
      const hasProtocolsOrSlottedExercises =
        (block.protocols && block.protocols.length > 0) ||
        block.workouts.some((workout) =>
          workout.exercises?.some((e) => e.protocolSlot != null)
        );

      const buttonContent = (
        <TouchableOpacity
          onPress={allWorkoutsHaveExercises ? showCopyWeek : undefined}
          disabled={!allWorkoutsHaveExercises}
          style={{
            flexShrink: 1,
            opacity:
              isHovered || !allWorkoutsHaveExercises || hasReachedMaxWeeks
                ? 0.6
                : 1,
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              height: 28,
              backgroundColor: !allWorkoutsHaveExercises
                ? Colors.grayColor
                : Colors.bubbleColor,
              borderRadius: 12,
              borderWidth: 1,
              borderColor: !allWorkoutsHaveExercises
                ? Colors.grayColor
                : Colors.bubbleColor,
              justifyContent: "center",
              alignItems: "center",
              flexShrink: 1,
            }}
          >
            <Text
              style={{
                textAlign: "center",
                textAlignVertical: "center",
                color: Colors.whiteColor,
                paddingHorizontal: 8,
                fontSize: 11,
                flexShrink: 1,
              }}
              numberOfLines={2}
            >
              {t("copyWeek-string")}
            </Text>
          </View>
        </TouchableOpacity>
      );

      return (
        <View style={{ flexShrink: 1 }}>
          {!allWorkoutsHaveExercises ? (
            <Tooltip
              content="addExercisesBeforeCreatingWeek-string"
              placement="top"
              maxWidth={250}
            >
              {buttonContent}
            </Tooltip>
          ) : (
            <Menu
              visible={showingCopyWeek}
              anchor={buttonContent}
              style={[GlobalStyles.menu, { marginLeft: isMobile ? 55 : 0 }]}
              onRequestClose={() => setCopyWeek(false)}
            >
              <MenuItemView index={0} />
              {showCopyActualToTarget && <MenuItemView index={1} />}
              {block.getWeeks + 1 < block.totalWeeks &&
                hasProtocolsOrSlottedExercises && <MenuItemView index={2} />}
            </Menu>
          )}
        </View>
      );
    });

    return (
      <View
        style={[
          GlobalStyles.HStack,
          {
            justifyContent: "space-between",
            marginBottom: screenSize === "large" ? 16 : 0,
            maxWidth: "100%",
            gap: 8,
          },
        ]}
      >
        <WeekPicker />
        <ButtonAddWeek />
      </View>
    );
  };

  const moveWorkout = (fromIndex, toIndex) => {
    const workouts = Array.from(block.selectedWeekWorkouts);
    const [movedExercise] = workouts.splice(fromIndex, 1);
    workouts.splice(toIndex, 0, movedExercise);

    workouts.forEach((ex, idx) => {
      ex.setProperty("order", idx);
    });
  };

  return (
    <View>
      <View
        style={[
          screenSize != "large" && GlobalStyles.HStack,
          {
            justifyContent:
              screenSize === "medium" ? "flex-start" : "space-between",
            marginBottom:
              screenSize === "small" ? 8 : screenSize === "medium" ? 0 : 0,
            marginTop:
              screenSize === "small" ? 0 : screenSize === "medium" ? 0 : 0,
          },
        ]}
      >
        <BlockButtons />
      </View>

      {screenSize != "large" ? (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "flex-start",
            flexWrap: "wrap",
            marginTop: screenSize === "medium" ? 16 : 8,
            gap: screenSize === "small" ? 8 : 12,
            marginBottom: screenSize === "small" ? 8 : 0,
          }}
        >
          {block.selectedWeekWorkouts &&
            block.selectedWeekWorkouts.map((workout, index) => {
              return (
                <React.Fragment key={`workout-${workout.id}-${index}`}>
                  <WorkoutRowView
                    workout={workout}
                    key={workout.id}
                    index={index}
                    moveWorkout={moveWorkout}
                  />
                </React.Fragment>
              );
            })}
          {block.selectedWeekWorkouts && (
            <AddRow
              action={addWorkout}
              shouldHighlight={coach?.highlightedComponent === "AddRow"}
              onHighlightDismiss={() => {
                coach?.setProperty("highlightedComponent", null);
              }}
            />
          )}
        </View>
      ) : (
        <View style={{ gap: 8 }}>
          {block.selectedWeekWorkouts &&
            block.selectedWeekWorkouts.map((workout, index) => (
              <WorkoutRowView
                key={workout.id}
                workout={workout}
                index={index}
                moveWorkout={moveWorkout}
              />
            ))}
          <AddRow
            action={addWorkout}
            shouldHighlight={coach?.highlightedComponent === "AddRow"}
            onHighlightDismiss={() => {
              coach?.setProperty("highlightedComponent", null);
            }}
          />
        </View>
      )}
      {showingDeleteWeekAlert && (
        <CustomAlert
          isVisible={showingDeleteWeekAlert}
          onClose={() => setShowingDeleteWeekAlert(false)}
          title={deleteWeekAlertTitle}
          text={deleteWeekAlertText}
          action={() => block.deleteWeek(block.weekToDelete)}
          specialCTA={"delete-string"}
        />
      )}
      {showingMaximumWeeksReachedAlert && (
        <CustomAlert
          isVisible={showingMaximumWeeksReachedAlert}
          onClose={() => setShowingMaximumWeeksReachedAlert(false)}
          title={"maximumWeeksReachedTitle-string"}
          text={"maximumWeeksReachedText-string"}
        />
      )}
      {showingSlotsNotAddedToWeekAlert && (
        <CustomAlert
          isVisible={showingSlotsNotAddedToWeekAlert}
          onClose={() => {
            setShowingSlotsNotAddedToWeekAlert(false);
            setPendingAction(null);
          }}
          title={"slotsNotAddedToWeekTitle-string"}
          text={t(
            warningActionType === "singleWeek"
              ? "slotsNotAddedToWeekText-string"
              : "slotsNotAddedToWeekAllWeeksText-string",
            {
              week: block.selectedWeek,
            }
          )}
          action={() => {
            if (pendingAction) {
              pendingAction();
            }
          }}
          specialCTA={"create-string"}
        />
      )}
      {showingAccessoriesNotAddedToWeekAlert && (
        <CustomAlert
          isVisible={showingAccessoriesNotAddedToWeekAlert}
          onClose={() => {
            setShowingAccessoriesNotAddedToWeekAlert(false);
            setPendingAction(null);
          }}
          title={"accessoriesNotAddedToWeekTitle-string"}
          text={t(
            warningActionType === "singleWeek"
              ? "accessoriesNotAddedToWeekText-string"
              : "accessoriesNotAddedToWeekAllWeeksText-string",
            {
              week: block.selectedWeek,
            }
          )}
          action={() => {
            if (pendingAction) {
              pendingAction();
            }
          }}
          specialCTA={"create-string"}
        />
      )}
    </View>
  );
});

export default BlockDescriptionView;
